/**
 * SVG noise texture overlay for dark sections.
 * Adds subtle grain for depth — a key 2026 design trend.
 */
export function NoiseTexture() {
  return (
    <div className="absolute inset-0 pointer-events-none opacity-[0.03]" aria-hidden="true">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <filter id="noise">
          <feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#noise)" />
      </svg>
    </div>
  );
}
